<template>
  <div class="analysis-page">
    <div class="nav-header">
      <span class="title">经营参谋</span>
    </div>

    <div class="filter-tab-bar">
      <div class="left-tabs">
        <span class="tab active">整体</span>
      </div>
      <div class="time-picker-trigger" @click="showTimePicker = true">
        {{ timeRangeLabel }} <i class="el-icon-arrow-down"></i>
      </div>
    </div>

    <div class="notice-banner" v-if="weeklyReport" @click="$router.push('/admin/weeklyReport')">
      <div class="notice-content">
        <p class="hi-text">Hi，最新经营周报已送达 <span class="dot"></span></p>
        <p class="date-range">{{ weeklyReport.startDate }}~{{ weeklyReport.endDate }} <span class="go-btn">去查看</span></p>
      </div>
      <img src="@/assets/image/chongdian.png" class="notice-img" />
    </div>

    <div class="data-card">
      <div class="card-title">
        <span>经营规模 <small>{{ totalDevices }}枪</small> <i class="el-icon-question"></i></span>
        <span class="more">更多 <i class="el-icon-arrow-right"></i></span>
      </div>
      <div class="grid-stats">
        <div class="stat-box" :class="{active: activeStat === 'serviceFee'}" @click="activeStat = 'serviceFee'">
          <p class="label">充电服务费(元) <i class="el-icon-question"></i></p>
          <p class="num">{{ formatNum(statsData.serviceFee) }}</p>
        </div>
        <div class="stat-box" :class="{active: activeStat === 'consumePower'}" @click="activeStat = 'consumePower'">
          <p class="label">充电量(度) <i class="el-icon-question"></i></p>
          <p class="num">{{ formatNum(statsData.consumePower) }}</p>
        </div>
        <div class="stat-box" :class="{active: activeStat === 'sumSales'}" @click="activeStat = 'sumSales'">
          <p class="label">订单总额(元) <i class="el-icon-question"></i></p>
          <p class="num">{{ formatNum(statsData.sumSales) }}</p>
        </div>
        <div class="stat-box" :class="{active: activeStat === 'sumCount'}" @click="activeStat = 'sumCount'">
          <p class="label">充电订单量 <i class="el-icon-question"></i></p>
          <p class="num">{{ statsData.sumCount || 0 }}</p>
        </div>
      </div>
      <div class="expand-btn" @click="showChart = !showChart">
        {{ showChart ? '收起趋势图' : '展开趋势图' }} <i :class="showChart ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
      </div>
      <div class="chart-container" v-if="showChart">
        <div ref="chartDom" class="chart"></div>
      </div>
    </div>

    <div class="analysis-list-card">
      <div class="card-title">枪分析</div>
      <div class="table-header">
        <span class="col-id">枪ID</span>
        <span class="col-data">日均度数 <i class="el-icon-sort"></i></span>
        <span class="col-data">充电量 <i class="el-icon-sort"></i></span>
      </div>
      <div class="table-row" v-for="(item, index) in gunAnalysisList" :key="index">
        <div class="row-main">
          <span class="gun-id">{{ item.deviceNo || item.id }}</span>
          <div class="gun-vals">
            <div class="val-group">
              <span class="v-num">{{ formatNum(item.avgPower) }}</span>
            </div>
            <div class="val-group">
              <span class="v-num">{{ formatNum(item.totalPower) }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="empty-tip" v-if="!loading && gunAnalysisList.length === 0">
        <i class="el-icon-s-order"></i>
        <p>暂无枪分析数据</p>
      </div>
    </div>

    <div class="time-popup-mask" v-if="showTimePicker" @click.self="showTimePicker = false">
      <div class="time-popup-content">
        <div class="p-header">
          <span>时间范围</span>
          <i class="el-icon-close" @click="showTimePicker = false"></i>
        </div>
        
        <div class="p-section">
          <p class="p-label">选择时间</p>
          <div class="p-grid">
            <span class="p-tag" :class="{active: timeRange === '7'}" @click="timeRange = '7'">近7天</span>
            <span class="p-tag" :class="{active: timeRange === '30'}" @click="timeRange = '30'">近30天</span>
            <span class="p-tag" :class="{active: timeRange === 'lastWeek'}" @click="timeRange = 'lastWeek'">上周</span>
            <span class="p-tag" :class="{active: timeRange === 'lastMonth'}" @click="timeRange = 'lastMonth'">上月</span>
            <span class="p-tag" :class="{active: timeRange === '12'}" @click="timeRange = '12'">近12月</span>
          </div>
        </div>

        <div class="p-footer">
          <div class="confirm-btn" @click="confirmTimeRange">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import { getChargingStatistics, getChargingPortStatistics, getPortPowerStats, getSalesDetail, getPileStatiscsList, getPilesInfo, getPortList } from "@/api/newApi";

export default {
  name: 'AnalysisPage',
  data() {
    return {
      showTimePicker: false,
      showChart: false,
      timeRange: '7',
      timeRangeLabel: '近7天',
      activeStat: 'serviceFee',
      statsData: {
        serviceFee: 0,
        consumePower: 0,
        sumSales: 0,
        sumCount: 0,
        serviceFeeTrend: 0,
        powerTrend: 0,
        salesTrend: 0,
        countTrend: 0
      },
      totalDevices: 0,
      gunAnalysisList: [],
      weeklyReport: null,
      chartData: [],
      loading: false
    };
  },
  computed: {
    timeRangeLabelMap() {
      return {
        '7': '近7天',
        '30': '近30天',
        'lastWeek': '上周',
        'lastMonth': '上月',
        '12': '近12月'
      };
    }
  },
  mounted() {
    this.getStatsData();
    this.getGunAnalysis();
  },
  methods: {
    getDateRange() {
      const now = new Date();
      const endTime = this.formatDate(now) + ' 23:59:59';
      let startTime = '';
      if (this.timeRange === '7') {
        const d = new Date(now.getTime() - 6 * 24 * 60 * 60 * 1000);
        startTime = this.formatDate(d) + ' 00:00:00';
      } else if (this.timeRange === '30') {
        const d = new Date(now.getTime() - 29 * 24 * 60 * 60 * 1000);
        startTime = this.formatDate(d) + ' 00:00:00';
      } else if (this.timeRange === '12') {
        const d = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate());
        startTime = this.formatDate(d) + ' 00:00:00';
      } else if (this.timeRange === 'lastWeek') {
        const d = new Date(now.getTime() - 13 * 24 * 60 * 60 * 1000);
        startTime = this.formatDate(d) + ' 00:00:00';
      } else if (this.timeRange === 'lastMonth') {
        const d = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        startTime = this.formatDate(d) + ' 00:00:00';
      }
      return { startTime, endTime };
    },
    formatDate(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    },
    async getStatsData() {
      try {
        const { startTime, endTime } = this.getDateRange();
        const [statRes, portRes] = await Promise.all([
          getChargingStatistics({ startTime, endTime }),
          getChargingPortStatistics({})
        ]);
        if (statRes.data) {
          this.statsData.serviceFee = statRes.data.totalServiceFee || 0;
          this.statsData.consumePower = statRes.data.totalConsumePower || 0;
          this.statsData.sumSales = statRes.data.totalOrderGold || 0;
          this.statsData.sumCount = statRes.data.totalOrderCount || 0;
        }
        if (portRes.data) {
          this.totalDevices = portRes.data.totalPortCount || 0;
        }
      } catch (err) {
        console.log('获取统计数据失败', err);
      }
    },
    async getGunAnalysis() {
      this.loading = true;
      try {
        const { startTime, endTime } = this.getDateRange();
        const res = await getPortPowerStats({ startTime, endTime });
        if (res.data && res.data.length > 0) {
          this.gunAnalysisList = res.data.map(item => ({
            deviceNo: item.portName || item.deviceId,
            id: item.portId,
            totalPower: item.totalConsumePower || 0,
            avgPower: item.avgDailyPower || 0,
            powerUp: 0,
            totalUp: 0
          })).slice(0, 20);
        } else {
          this.gunAnalysisList = [];
        }
      } catch (err) {
        console.log('获取枪分析失败', err);
        this.gunAnalysisList = [];
      } finally {
        this.loading = false;
      }
    },
    async getChartData() {
      try {
        const res = await getSalesDetail({ pageNo: 1, pageSize: 30 });
        if (res.data && res.data.records) {
          const records = res.data.records;
          let chartData = [];
          if (this.activeStat === 'serviceFee') {
            chartData = records.map(r => ({ date: r.createTime, value: r.serviceFee || 0 }));
          } else if (this.activeStat === 'consumePower') {
            chartData = records.map(r => ({ date: r.createTime, value: parseFloat(r.totalPowerConsumption) || 0 }));
          } else if (this.activeStat === 'sumSales') {
            chartData = records.map(r => ({ date: r.createTime, value: r.sumSales || 0 }));
          } else {
            chartData = records.map(r => ({ date: r.createTime, value: r.sumCount || 0 }));
          }
          this.chartData = chartData.reverse();
          this.initChart();
        }
      } catch (err) {
        console.log('获取图表数据失败', err);
      }
    },
    calculateTrends() {
      const base = 0;
      this.statsData.serviceFeeTrend = base;
      this.statsData.powerTrend = base;
      this.statsData.salesTrend = base;
      this.statsData.countTrend = base;
    },
    getDaysByRange() {
      const map = { '7': 7, '30': 30, '12': 365, 'lastWeek': 7, 'lastMonth': 30 };
      return map[this.timeRange] || 7;
    },
    confirmTimeRange() {
      this.timeRangeLabel = this.timeRangeLabelMap[this.timeRange];
      this.showTimePicker = false;
      this.getStatsData();
      this.getGunAnalysis();
      if (this.showChart) {
        this.getChartData();
      }
    },
    showWeeklyReport() {
      console.log('查看周报');
    },
    formatNum(num) {
      if (num === null || num === undefined) return '0';
      const n = parseFloat(num);
      if (isNaN(n)) return '0';
      return n.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    initChart() {
      this.$nextTick(() => {
        const chartDom = this.$refs.chartDom;
        if (!chartDom) return;
        const myChart = echarts.init(chartDom);
        const dates = this.chartData.map(d => d.date ? d.date.substring(5) : '');
        const values = this.chartData.map(d => d.value);
        const option = {
          grid: { top: 10, left: 35, right: 35, bottom: 20 },
          xAxis: {
            type: 'category',
            data: dates,
            axisLine: { lineStyle: { color: '#EEE' } },
            axisLabel: { color: '#999', fontSize: 10 }
          },
          yAxis: {
            type: 'value',
            splitLine: { lineStyle: { type: 'dashed', color: '#F0F0F0' } },
            axisLabel: { color: '#999', fontSize: 10 }
          },
          series: [{
            data: values,
            type: 'line',
            smooth: true,
            symbol: 'none',
            color: '#00BFA5',
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(0, 191, 165, 0.2)' },
                { offset: 1, color: 'rgba(0, 191, 165, 0)' }
              ])
            }
          }]
        };
        myChart.setOption(option);
      });
    }
  },
  watch: {
    showChart(val) {
      if (val) {
        this.getChartData();
      }
    },
    activeStat() {
      if (this.showChart) {
        this.getChartData();
      }
    },
    timeRange(val) {
      this.timeRangeLabel = this.timeRangeLabelMap[val];
      this.getStatsData();
      this.getGunAnalysis();
    }
  }
};
</script>

<style lang="scss" scoped>
.analysis-page {
  background-color: #F7F9FC;
  min-height: 100vh;
}

.nav-header {
  padding: 15px 16px;
  background: #FFF;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title { font-size: 18px; font-weight: bold; }
  .right-action { font-size: 13px; color: #666; i { color: #00BFA5; } }
}

.filter-tab-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  background: #FFF;
  .tab {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    border-bottom: 3px solid #00BFA5;
    padding-bottom: 4px;
  }
  .time-picker-trigger {
    background: #F2F4F7;
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 13px;
    color: #333;
  }
}

.notice-banner {
  margin: 12px 16px;
  background: #E8F9F8;
  border-radius: 12px;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .hi-text { font-weight: bold; font-size: 15px; .dot { width: 6px; height: 6px; background: red; border-radius: 50%; display: inline-block; vertical-align: top; } }
  .date-range { font-size: 12px; color: #999; margin-top: 5px; }
  .go-btn { background: #00BFA5; color: #FFF; padding: 2px 8px; border-radius: 10px; margin-left: 5px; }
  .notice-img { width: 50px; }
}

.data-card {
  background: #FFF;
  margin: 12px 16px;
  border-radius: 12px;
  padding: 15px;
  .card-title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    font-weight: bold;
    small { color: #999; font-weight: normal; margin-left: 5px; }
    .more { color: #BBB; font-weight: normal; font-size: 13px; }
  }
  .grid-stats {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    .stat-box {
      background: #F8FAFB;
      padding: 12px;
      border-radius: 8px;
      border: 1px solid transparent;
      cursor: pointer;
      &.active { border-color: #00BFA5; background: #FFF; }
      .label { font-size: 11px; color: #999; margin-bottom: 5px; }
      .num { font-size: 18px; font-weight: bold; margin-bottom: 5px; }
      .trend { font-size: 11px; &.down { color: #52C41A; } &.up { color: #F5222D; } }
    }
  }
  .expand-btn { text-align: center; color: #BBB; font-size: 12px; margin-top: 15px; cursor: pointer; }
  .chart-container {
    margin-top: 15px;
    .chart { width: 100%; height: 200px; }
  }
}

.analysis-list-card {
  background: #FFF;
  margin: 12px 16px;
  border-radius: 12px;
  padding: 15px;
  .card-title { font-weight: bold; margin-bottom: 10px; }
  .table-header {
    display: flex;
    padding: 10px 0;
    color: #999;
    font-size: 12px;
    border-bottom: 1px solid #F0F0F0;
    .col-id { flex: 1; }
    .col-data { width: 80px; text-align: right; }
  }
  .table-row {
    padding: 15px 0;
    border-bottom: 1px solid #F0F0F0;
    .row-main {
      display: flex;
      align-items: center;
      .gun-id { flex: 1; font-size: 14px; color: #333; }
      .gun-vals {
        display: flex;
        .val-group {
          width: 80px;
          text-align: right;
          display: flex;
          flex-direction: column;
          .v-num { font-size: 14px; font-weight: bold; }
          .v-trend { font-size: 10px; margin-top: 2px; &.up { color: #F5222D; } &.down { color: #52C41A; } }
        }
      }
    }
  }
  .empty-tip {
    text-align: center;
    padding: 40px 0;
    color: #999;
    i { font-size: 48px; margin-bottom: 10px; }
    p { font-size: 14px; }
  }
}

.time-popup-mask {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.5);
  z-index: 2000;
  display: flex;
  align-items: flex-end;
}
.time-popup-content {
  background: #FFF;
  width: 100%;
  border-radius: 16px 16px 0 0;
  padding: 20px 16px 30px;
  .p-header {
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 25px;
    i { color: #999; }
  }
  .p-label { font-size: 15px; font-weight: bold; margin-bottom: 15px; }
  .p-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    margin-bottom: 25px;
    .p-tag {
      background: #F5F7FA;
      padding: 10px 0;
      text-align: center;
      border-radius: 8px;
      font-size: 14px;
      color: #333;
      border: 1px solid transparent;
      cursor: pointer;
      &.active { background: #E6F9F7; border-color: #00BFA5; color: #00BFA5; }
    }
  }
  .confirm-btn {
    background: #00BFA5;
    color: #FFF;
    text-align: center;
    padding: 14px 0;
    border-radius: 25px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
  }
}
</style>